import { Stack, repeat } from "@hopper-ui/components";
import { GridCardList, GridCardListItem, type GridCardListItemRenderFunction } from "@sg-protect/components";
import { Outlet } from "react-router";
import { ASSESSMENT_TABS } from "#components/assessmentTabs.ts";
import { useAssessmentSections } from "#hooks/useAssessmentSections.ts";
import { AssessmentSectionCard } from "./AssessmentSectionCard.tsx";

const renderActiveCard: GridCardListItemRenderFunction = (props, renderProps, baseRenderer) =>
    baseRenderer(props, { ...renderProps, isSelected: true });

export function AssessmentCardNav() {
    const sections = useAssessmentSections();

    return (
        <Stack gap="stack-lg">
            <GridCardList
                aria-label="Assessment sections"
                gridTemplateColumns={{
                    base: repeat(1, "1fr"),
                    sm: repeat(2, "1fr"),
                    lg: repeat(ASSESSMENT_TABS.length, "1fr")
                }}
            >
                {sections.map(({ pathKey, href, label, icon: Icon, isActive, total }) => (
                    <GridCardListItem
                        key={pathKey}
                        id={href}
                        href={href}
                        textValue={isActive ? `${label} (current page)` : label}
                        render={isActive ? renderActiveCard : undefined}
                    >
                        <AssessmentSectionCard label={label} icon={Icon && <Icon size="sm" />} total={total} />
                    </GridCardListItem>
                ))}
            </GridCardList>
            <Outlet />
        </Stack>
    );
}
